import axios from "../axios";
export async function createEmployee(payload) {
  return axios
    .post(`/users/${payload?.user_id}/employees/`, {
      employee: payload,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateEmployee(payload) {
  return axios
    .put(`/users/${payload?.user_id}/employees/${payload?.employment_id}`, {
      employee: payload,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export async function fetchEmployee(payload) {
  return axios
    .get(`/users/${payload?.user_id}/employees/${payload?.employment_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response;
    });
}

export async function downloadEmployeeContractDraft(payload) {
  return axios.get(
    `/users/${payload?.user_id}/employees/${payload?.employment_id}/contract_draft_pdf`,
    {
      responseType: "blob",
    }
  );
}
